module.exports = __webpack_public_path__ + "img/About-us_retail.1752441f.jpg";